const getQueryString = () => {
    const params = new URLSearchParams(window.location.search);
    return Object.fromEntries(params.entries());
};

const setQueryString = (values) => {
    window.location.search = Object.keys(values).map(k => `${k}=${values[k]}`).join("&");
}

export {
    getQueryString,
    setQueryString
}